export default __webpack_public_path__ + "static/media/a1.71aa0020.webp";